import { Dispatch, SetStateAction, useCallback } from 'react';
import { ITaskGroup } from '../../../../models/taskGroup.types';
import { ExaminerType } from '../../ExaminerTreemap.types';
import { SubText } from '../../../../components/Prompt/Prompt.component';
import { ActionMenuItem } from '../../../../components/ActionsMenu/ActionsMenu.types';
import ActionsMenu from '../../../../components/ActionsMenu/ActionsMenu.component';

export type UseSampleAssessmentGroupActionsMenuProps = {
  data: ITaskGroup[];
  setAction: Dispatch<SetStateAction<string>>;
  selectedTaskGroup: React.MutableRefObject<ITaskGroup | undefined>;
  setPromptSubTexts: React.Dispatch<React.SetStateAction<SubText[] | undefined>>;
  setPromptMainText: React.Dispatch<React.SetStateAction<string>>;
  setIsConfirmationPromptVisible: React.Dispatch<React.SetStateAction<boolean>>;
  selectedItemId: React.MutableRefObject<string>;
  openAssignModal: (title: string, type: ExaminerType, isMultiChoice?: boolean, assessmentId?: string) => void;
};

export const useSampleAssessmentGroupActionsMenu = ({
  data,
  selectedItemId,
  selectedTaskGroup,
  setAction,
  setIsConfirmationPromptVisible,
  setPromptMainText,
  setPromptSubTexts,
  openAssignModal,
}: UseSampleAssessmentGroupActionsMenuProps) => {
  const isZWORemoveDisabled = (item: ITaskGroup) => {
    return (
      item.sampleAssessmentGroup?.sampleAssessmentChairman.examiner !== null ||
      item.sampleAssessmentGroup?.sampleAssessmentMembers.length > 0
    );
  };

  const displayRemoveSampleAssessmentGroupPrompt = useCallback(() => {
    const taskGroup = data.find(
      (taskGroup) => taskGroup.sampleAssessmentGroup?.sampleAssessmentsGroupId === selectedItemId.current,
    );
    if (taskGroup) {
      selectedTaskGroup.current = taskGroup;
      setPromptMainText('Czy na pewno chcesz usunąć Zespół Wzorcowych Ocen (ZWO) z:');
      const subTexts: SubText[] = [
        {
          text: `${taskGroup.name}`,
        },
      ];
      setPromptSubTexts(subTexts);
      setIsConfirmationPromptVisible(true);
    }
  }, [data]);

  const getSampleAssessmentGroupActionsMenu = useCallback(
    (item: ITaskGroup, assessmentId: string, rowIndex: number): JSX.Element => {
      const menuItems: ActionMenuItem[] = [];
      menuItems.push({
        text: 'Dodaj członka ZWO',
        onClick: () => {
          setAction('Dodaj członka ZWO');
          openAssignModal('Dodaj Egzaminatora/Egzaminatorów do ZWO:', 'ZWO', true, assessmentId);
        },
      });
      menuItems.push({
        disabled: isZWORemoveDisabled(item),
        text: 'Usuń ZWO',
        onClick: () => {
          setAction('Usuń ZWO');
          displayRemoveSampleAssessmentGroupPrompt();
        },
      });
      return <ActionsMenu menuItems={menuItems} rowIndex={rowIndex} />;
    },
    [displayRemoveSampleAssessmentGroupPrompt, openAssignModal, setAction],
  );

  return { getSampleAssessmentGroupActionsMenu };
};
